import React from 'react';
import { styled } from '@mui/material/styles';
import Heading3 from 'components/common/subcomponents/Typography/Heading3';

const Container = styled('div')(({ theme: _theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '50px 0 20px 0',
}));

const SectionTitle = ({ module }) => {
  const { fields } = module;

  return (
    <Container>
      <Heading3 color="#000" underline={true} uppercase={true}>
        {fields.title}
      </Heading3>
    </Container>
  );
};

export default SectionTitle;

